'use strict';

app.factory('DashboardDataServiceCarrefour', function ($http, $state, $q, $interval, ApiService) {
    return {
        dataProvider: dataProvider,
        getTileLayout: getTileLayout,
        getData: getData,
        goto: goto,
    }

    function dataProvider() {
        return 'Carrefour';
    }

    function goto(tile, item) {
        var params = {};
        switch (tile.title) {
            case 'Mise à jour':
                params.name = item.name;
                params.value = item.value;
                params.image = item.image;
                params.z = 28;
                $state.go('app.list.set', params);
                break;
            default:
                console.log("State not found for tile: " + tile.title);
                break;
        }

    }

    function getTileLayout() {
        var tiles = [
            {
                title: 'PAP',
                type: 'counter',
                template: '',
                width: 1, height: 1,
                dataSource: '/api/dashboard/getdata',
                interval: 5000,
                value: [
                ],
            },
            {
                title: 'Production',
                type: 'table',
                template: '',
                width: 1, height: 2,
                dataSource: '/api/dashboard/getdata',
                interval: 10000,
                value: [
                ],
            },
            //{
            //    title: 'Placeholder',
            //    type: 'placeholder',
            //    template: '',
            //    width: 1, height: 1,
            //    dataSource: '/api/dashboard/getdata',
            //    interval: 10000,
            //    classhtml: 'block-counter',
            //    value: '100',
            //    label: 'Placeholder',
            //    image: 'maquette-carrefour.png'
            //},
            {
                title: 'Mise à jour',
                type: 'table',
                template: '',
                width: 1, height: 2,
                dataSource: '/api/dashboard/getdata',
                value: [
                ],
            },
            //{
            //    title: 'Template',
            //    type: 'table',
            //    template: '2',
            //    width: 1, height: 2,
            //    dataSource: '/api/dashboard/getdata',
            //    classhtml: 'block-counter',
            //    value: [
            //    ],
            //},
            //{
            //    title: 'Top des services',
            //    type: 'table',
            //    template: '3',
            //    width: 1, height: 2,
            //    dataSource: '/api/dashboard/getdata',
            //    classhtml: 'block-counter',
            //    value: [
            //    ],
            //},
            //{
            //    title: 'Publications',
            //    type: 'text',
            //    template: '',
            //    width: 1, height: 2,
            //    dataSource: 'inline',
            //    classhtml: 'block-counter',
            //    value: ' <ul><li class="publication">Date de sortie du guide papier :<span>25/08/2017</span></li></ul><p class="list-city"><span><a>Paris</a></span> |<span><a>Tokyo</a></span> |<span><a>Amsterdam</a></span> |<span><a>Bangkok</a></span> |<span><a>Berlin</a></span> |<span><a>Chicago</a></span> |<span><a>Hong Kong</a></span> |<span><a>New York</a></span> |<span><a>Londres</a></span> |<span><a>Lisbonne</a></span></p>',
            //},
              //{
              //    title: 'Chartdonut',
              //    type: 'donut',
              //    template: '',
              //    image: 'nb_elements_map.png',
              //    width: 1, height: 2,
              //    dataSource: '/api/dashboard/getdata',
              //    value: [
              //    ],
              //},
            //{
            //    title: 'News',
            //    type: 'slide',
            //    template: '',
            //    width: 1, height: 2,
            //    dataSource: '/api/dashboard/getdata',
            //    value: [
            //    ],
            //}
          
        ];

        return $q.when(tiles);
    }

    function getData(tile) {
        return ApiService.get(tile.dataSource + '?title=' + tile.title + '&lang=' + 'fr').then(
            function (response) {
                return response.data;
            });
    }


});
